import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateRateTypes } from "@/redux/reducers/rateTypes";

const getRateTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getRateTypes: builder.query({
      query: () => "parameters/rate-types",
      transformResponse: response => response.items,
      providesTags: ["RateTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateRateTypes(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetRateTypesQuery } = getRateTypes;

